/**
 * メッセージ定数定義
 *
 */
export default class MessageConst {
    // 共通メッセージ
    public static readonly S_CONFIRMATION: string = '{0}を実行します。よろしいですか？';
    public static readonly S_CREATE: string = '{0}を作成します。\nよろしいですか？';
    public static readonly E_REQUIRED: string = '{0}を入力してください。';
    public static readonly E_MAX: string = '{0}は{1}文字以内で入力してください。';
    public static readonly E_MAX_LENGTH: string = '{0}は{1}以下で入力してください。';
    public static readonly E_SIZE: string = '{0}は{1}文字で入力してください。';
    public static readonly E_REGEX: string = '{0}は{1}で入力してください。';
    public static readonly E_EMAIL: string = '正しい形式の{0}を入力してください。';
    public static readonly E_CREATE_MAIL: string = '{0}が生成できませんでした。';
    public static readonly E_UNSELECTED: string = '{0}を選択してください。';
    public static readonly E_MIN_MAX: string = '{0}は{1}文字以上、{2}文字以下で入力してください。';
    public static readonly E_MIN_MAX_PARAM: string = '{0}は{1}以上、{2}以下で入力してください。';
    public static readonly E_MIN_MAX_LENGTH: string = '{0}は{1}～{2}の範囲で入力してください。';
    public static readonly E_PASSWORD_REGEX: string = '有効なパスワード入力してください。';
    public static readonly E_PASSWORD_NOT_MATCH: string = 'パスワードが一致していません。';
    public static readonly E_SYSTEM_ERROR: string = 'システムエラーが発生しました。';
    public static readonly E_NOT_FOUND: string = '{0}が見つかりません。';
    public static readonly E_BECAUSE_OF: string = "{0}のため{1}できません。";
    public static readonly E_DATE_ORDER: string = "開始日付≦終了日付となるよう入力してください。";
    public static readonly E_NUM_ORDER: string = "最小値は最大値以下の数値を入力してください。";
    public static readonly E_INPUT_AT_LEAST_ONE: string = "少なくとも片方は入力してください。";
    public static readonly E_CHECK_AT_LEAST_ONE: string = "少なくとも１つはチェックしてください。";
    public static readonly E_SELECT_ONE: string = "選択してください。";
    public static readonly E_ADDRESS_START_END_ERR: string = '先頭、末尾での{0}の入力は不可です。';
    public static readonly E_ADDRESS_DOMAIN_START_END_ERR: string = 'メールアドレスのドメインにて、先頭、末尾での{0}の入力は不可です。';
    public static readonly E_ADDRESS_PERIOD_ERR: string = '連続での{0}の入力は不可です。';
    public static readonly E_FAILED: string = '{0}に失敗しました。';
    public static readonly E_OUTPUT_FILE_NO_DATA: string = '出力データがありません。';
    public static readonly E_FILE_EXTENSION_DUPLICATE: string = 'ファイル拡張子が重複しています。';
    public static readonly S_NO_ERROR_MESSAGE: string = 'エラーはありません。';
    public static readonly E_ONLY_BLANK: string = '{0}は改行や半角・全角スペースのみの登録ができません。';

    // 氏名エラーチェック
    public static readonly E_REGEX_NAME: string = '{0}にスペースは使用できません。';

    // Excelファイルチェックエラーメッセージ
    public static readonly E_FILE_REQUIRED: string = 'ファイルを選択してください。';
    public static readonly E_FILE_NO_DATA: string = '対象のファイルはデータがありません。';
    public static readonly E_FILE_MAX_SIZE: string = '{0}KB以内のファイルを選択してください。';
    public static readonly E_FILE_EXTENSION: string = '{0}拡張子ファイルを選択してください。';
    public static readonly E_FILE_FILE_COUNT: string = '{0}ファイルは{1}で選択してください。';
    public static readonly E_FILE_NAME_DUPLICATE: string = '異なるファイル名のファイルを選択してください。';

    // ファイルドロップエリア
    public static readonly I_FILE_DROP_AREA_MESSAGE: string =
        'クリックしてファイルを選択\n' +
        'または\n' +
        'ファイルをドラッグ＆ドロップしてください';
    public static readonly I_FILE_INFO: string = 'ファイル名：{0}\nファイルサイズ：{1} KB';

    // パラメータ管理：カテゴリ設定バリデーションエラーメッセージ
    public static readonly E_VALIDATE_INVALID_VALUE: string = '{0}、{1}の値が不正です。';
    public static readonly E_VALIDATE_REQUIRED: string = '{0}、{1}を入力してください。';
    public static readonly E_VALIDATE_MAX: string = '{0}、{1}は{2}文字以内で入力してください。';
    public static readonly E_VALIDATE_REGEX: string = '{0}、{1}は{2}で入力してください。';
    public static readonly E_VALIDATE_DUPLICATE: string = '{0}、{1}が重複しています。';
    public static readonly E_VALIDATE_EMAIL: string = '{0}、正しい形式の{1}を入力してください。';
    public static readonly E_VALIDATE_ADDRESS_END_ERR: string = '{0}、{1}の末尾での{2}の入力は不可です。';
    public static readonly E_VALIDATE_ONLY_SPACE: string = '{0}、{1}は半角・全角スペースのみの登録ができません。';

    public static readonly E_SETTING_AFTER_ORGANIZATION: string = '変換先組織が設定されていないデータがあります。';
    public static readonly E_EXIST_AFFILIATION_CODE_CONVERSION: string = '登録対象のデータがありません。';

    public static readonly DELETED_ORG: string = '（削除された組織）';
}
